export default __webpack_public_path__ + "static/media/eco-sub-image-01.913ebf19.png";